module.exports = __webpack_public_path__ + "img/rattasat_l.405beb73.webp";